export const PERIOD = {
  month: 'month',
  year: 'year',
} as const;
